module.exports = __webpack_public_path__ + "img/waving-hands.f73e1854.svg";